var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedIn(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16Z",
    fill: "#7C7C7C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.546 9.8818C11.546 10.9279 10.7586 11.7649 9.49426 11.7649H9.47108C8.25377 11.7649 7.4668 10.9279 7.4668 9.8818C7.4668 8.8136 8.27774 8 9.51815 8C10.7586 8 11.5224 8.8136 11.546 9.8818ZM11.3072 13.2519V24.1464H7.68121V13.2519H11.3072ZM24.3836 24.1464L24.3837 17.8998C24.3837 14.5535 22.5949 12.9961 20.2089 12.9961C18.2837 12.9961 17.4218 14.0535 16.9406 14.7953V13.2522H13.3142C13.362 14.2745 13.3142 24.1467 13.3142 24.1467H16.9406V18.0623C16.9406 17.7367 16.9641 17.4119 17.06 17.1788C17.322 16.5283 17.9187 15.8548 18.9205 15.8548C20.2331 15.8548 20.7578 16.8538 20.7578 18.3178V24.1464H24.3836Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/LinkedIn.4b9072da2fe8e723fa97b8a827d6dcd2.svg";
export { ForwardRef as ReactComponent };